// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eMb1","icon":"styles_icon__4iZOU"};